<div class="_reset-page">

	<div class="_container">

		<img class="_logo" src="./assets/BEEGO_logo.png" />

		<ng-container *ngIf="!this.isOk">

			<ng-container *ngIf="!code">
				
				<div class="_header">
					<p class="_title" [translate]="'RESET.INTRO_USERNAME'"></p>
					<p [translate]="'RESET.PASSWORD_RESET_INFO'"></p>
				</div>
				
				<form [formGroup]="resetRequestForm">
					<div class="_inputs">
	
						<ion-input name="username" [formControl]="resetRequestForm.get('username') | cast" placeholder="{{ 'LOGIN.USERNAME' | translate}}" (keyup.enter)="reset()">
							<ion-icon src="./assets/icons/user.svg"></ion-icon>
						</ion-input>
						<form-validation-error [control]="resetRequestForm.get('username') | cast"></form-validation-error>
						
					</div>
				</form>
			</ng-container>
			
			<ng-container *ngIf="code">
				<p class="_title" [translate]="'RESET.INTRO_PASSWORD'"></p>

				<form [formGroup]="resetConfirmForm">
					<div class="_inputs" formGroupName="password">
	
						<p [translate]="'RESET.PASSWORD_REQUIREMENTS'">
						</p>
	
						<ion-input 
							[formControl]="resetConfirmForm.controls.password.get('new') | cast" 
							type="password" 
							placeholder="{{ 'CHANGE_PASSWORD.NEW_PASSWORD' | translate }}" 
							(keyup.enter)="reset()"
							>
							<ion-icon src="./assets/icons/password.svg"></ion-icon>
						</ion-input>
						<form-validation-error [control]="resetConfirmForm.controls.password.get('new') | cast"></form-validation-error>
	
						<ion-input 
							[formControl]="resetConfirmForm.controls.password.get('confirmation') | cast" 
							type="password" 
							placeholder="{{ 'CHANGE_PASSWORD.CONFIRMATION_PASSWORD' | translate }}" 
							(keyup.enter)="reset()"
						>
							<ion-icon src="./assets/icons/password.svg"></ion-icon>
						</ion-input>
						<form-validation-error [control]="resetConfirmForm.controls.password.get('confirmation') | cast"></form-validation-error>
						<form-validation-error [control]="resetConfirmForm.get('password') | cast"></form-validation-error>
						
					</div>
				</form>
			</ng-container>
			
			<div class="_buttons">
				<button class="_button _reset-button" (click)="reset()" [disabled]="resetRequestForm.invalid && resetConfirmForm.invalid"><span [translate]="'RESET.RESET_BUTTON'" ></span></button>
				<button class="_button _back-to-login-button" (click)="navigateToLogin()"><span [translate]="'RESET.GO_TO_LOGIN'" ></span></button>
			</div>

		</ng-container>

		<ng-container *ngIf="this.isOk">
			<ng-container *ngIf="!code">
				<p class="_success" [translate]="'REGISTER.EMAIL_SUCCESS'"></p>
			</ng-container>
			<ng-container *ngIf="code">
				<p class="_success" [translate]="'REGISTER.PASSWORD_SUCCESS'"></p>
			</ng-container>
			<div class="_buttons">
				<button class="_button _reset-button" (click)="navigateToLogin()"><span [translate]="'RESET.GO_TO_LOGIN'" ></span></button>
			</div>
		</ng-container>
		
	</div>

</div>
